(function () {

    'use strict';

    angular.module('itxApp.catalog')
        .directive('itxFiltersColorCheck', ItxFiltersColorCheckDrt);

    /**
     * Directive for changing the background image for the corresponding color from static resources
     */
    function ItxFiltersColorCheckDrt() {
        return {
            //Can apply to
            restrict: 'A',
            priority: 2,
            scope: {
                itxFiltersColorCheck: '='
            },
            //Directive link function
            link: function (scope) {
                var styles;

                if (!scope.itxFiltersColorCheck) {
                    return;
                }

                styles = document.querySelectorAll('style[id=colors]');

                if (!styles.length) {
                    var stElement = document.createElement('style');
                    stElement.id = 'colors';
                    document.head.appendChild(stElement);
                }

                styles = document.querySelectorAll('style[id=colors]')[0];

                var imageUrl = inditex.getStaticResourceUrl('/images/colors/' + scope.itxFiltersColorCheck + '.jpg');

                styles.innerHTML =
                    [
                        styles.innerHTML,
                        ' ',
                        'label[for="', scope.itxFiltersColorCheck, '"] .color-plain',
                        '{',
                            'background: url(', encodeURI(imageUrl), ') !important;',
                            'background-size: cover !important;',
                        '}'
                    ].join('');
            }
        };
    }

})();
